const NthColsTable = ({frontEndId = '', isTTG, foPool,  betType, combStrs, lblFunc, isMobile, getOddsVal, expand, isCloseLine }) => {
    let line = isCloseLine ? foPool?.closedLines[0] : foPool?.lines[0];
    let newCombStrs = combStrs
    if(window.globalConfig.enableTTGExpand && isTTG && isMobile && !expand) {
        newCombStrs = combStrs.filter((str, i) => {
            let comb = null;
            comb = line?.combinations.filter(x => x.selections?.[0]?.str == str)[0];
            const isIRRATIONAL = comb.status === 'IRRATIONAL';
            return !isIRRATIONAL;
        })
        if(newCombStrs.length < 3) {
            newCombStrs = [...newCombStrs, ...combStrs];
        }

    }
    return newCombStrs.map((str, i) => {
        const s = lblFunc(str)
        const combId = line.combinations.find((combination) => combination.str === str)?.combId;
        
        return !isMobile || expand || i<3 ? <div>
            <div 
                className='goals-number'
                data-testid={`${frontEndId}_${betType}_${line?.lineId}_${combId}_${foPool?.id}_${s}`}
            >
                {s}
            </div>
            {getOddsVal(line, str, isMobile)}
        </div> : null
    })
}
export default NthColsTable